import '@fancyapps/fancybox'
import Diacritics from './normalize.js'
import md5 from 'md5'
import Cleave from 'cleave.js'
import tippy from 'tippy.js'
import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear.js'
// -----------------------------------------------------
// Ajouter lib DD => main.js +53kB compressé.
// Celui-ci sert à envoyer manuellement des logs.
// -----------------------------------------------------
import './datadog/ddLogger.js'

// -----------------------------------------------------
// RUM et catch d'erreurs.
// Ajouter lib DD RUM => main.js +109kB compressé.
// -----------------------------------------------------
//import './datadog/ddRum.js'

dayjs.extend(weekOfYear)

window.Diacritics = Diacritics
window.md5 = md5
window.Cleave = Cleave
window.tippy = tippy

window.dayjs = dayjs
